export interface ServerConfig {
  mainServerUrl: string;
  gameServerUrl?: string;
}

const DEFAULT_MAIN_SERVER_URL = 'http://localhost:30086';

export const serverConfig: ServerConfig = {
  mainServerUrl: import.meta.env.VITE_MAIN_SERVER_URL ?? DEFAULT_MAIN_SERVER_URL,
  gameServerUrl: import.meta.env.VITE_GAME_SERVER_URL,
};
